export default __webpack_public_path__ + "static/media/welcome-2.0a85f7ea.jpeg";